import React, {FunctionComponent, MouseEvent, useCallback, useEffect, useRef, useState} from "react";

import {
    ACard,
    ADataGrid, ADataGridColors,
    ADataGridColumn,
    ADataGridFilter,
    PagedSearchParams,
} from "@atiautomacao/ati-ui-library";
import {extractFiltersFromColumns} from "../../../../Utils/DataUitils";
import {RootState} from "../../../../Config/Store";
import {useAppDispatch, useAppSelector} from "../../../../Config/Hooks";
import { mergeAndDeduplicateFilters } from "../../../../Utils/FilterMergeUtils";
import {Alarm, clear, searchEntities} from "./AlarmSkidReducer";
import IconButton from "@mui/material/IconButton";
import {BorderColor, FactCheck, FilterAltOutlined} from "@mui/icons-material";
import {isArray} from "lodash";
import {DateFormat} from "../../../../Utils/DateFormatPatternUtils";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link, Modal, useTheme} from "@mui/material";
import VolumeUpIcon from '@mui/icons-material/VolumeUp';

import {usePowerStationNavigation} from "../../../../Shared/Hooks/usePowerStationNavigation";
import {useSkidNavigation} from "../../../../Shared/Hooks/useSkidNavigation";
import AlarmGroup from "./Components/AlarmGroup";
import {alarmSearchGroup, checkGroupingType, getAlarmDisplayLabel, handleOnColor} from "../../../../Utils/AlarmsService";
import {useSnackbar} from "notistack";
import AlarmNotion from "../../Alarms/Components/AlarmNotion";
import {clearGroup} from "../../Alarms/Components/AlarmGroup/AlarmGroupReducer";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import Tooltip from '@mui/material/Tooltip';
import { LoadingButton } from "@mui/lab";
import {Storage} from "../../../../Utils/StorageUtils";
import {alarmAcknowledge, alarmFinalize, AlarmActionArgs} from "../../Alarms/AlarmReducer";
import useInterval from "../../../../Shared/Hooks/useInterval";
import { hasPermission } from "../../../../Shared/Auth/AuthenticationUtil";
import { AUTHORITIES } from "../../../../Config/Constants";
import {useEquipmentNavigation} from "../../../../Shared/Hooks/useEquipmentNavigation";
import {useEquipmentWithoutSkidNavigation} from "../../../../Shared/Hooks/useEquipmentWithoutSkidNavigation";
import {
    applyFiltersToAlarmColumns,
    buildAlarmDateFilterSanitizationMessage,
    buildAlarmDateFilterValidationMessage,
    processAlarmDateFilters,
} from "../../../../Utils/AlarmDateFilterValidationUtils";

export const initColumns = [
    {
        name: 'id',
        label: 'ID',
        align: 'left',
        visibility: false,
        minWidth: 10,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'severityName',
        label: 'severidade',
        align: 'left',
        minWidth: '1vw',
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
    },
    {
        name: 'description',
        label: 'descrição',
        align: 'left',
        minWidth: '15vw',
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'macroRegionName',
        label: 'macro',
        align: 'left',
        visibility: false,
        minWidth: 10,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'regionName',
        label: 'região',
        align: 'left',
        minWidth: 10,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'equipmentName',
        label: 'equipamento',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'dateTime',
        label: 'início',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {
            name: "dateTime",
            condition: "starts-at",
            value: "",
            sort: "none",
            placeholder: 'dd/MM/yyyy HH:mm:ss'
        }
    },
    {
        name: 'clearDate',
        label: 'finalizado',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {
            name: "clearDate",
            condition: "starts-at",
            value: "",
            sort: "none",
            placeholder: 'dd/MM/yyyy HH:mm:ss'
        }
    },
    {
        name: 'acknowledgementDate',
        label: 'reconhecido',
        align: 'left',
        minWidth: 10,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {
            name: "acknowledgementDate",
            condition: "starts-at",
            value: "",
            sort: "none",
            placeholder: 'dd/MM/yyyy HH:mm:ss'
        }
    },
    {
        name: 'userName',
        label: 'usuário',
        align: 'left',
        visibility: true,
        minWidth: 10,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
] as ADataGridColumn[]

export type ActionConfig = {
    actionName: string;
    disabled: boolean;
}
export interface AlarmRow {
    id: string;
    teleObjectId: number;
    teleObjectInhibited: boolean;
    severityId: number;
    severityName: string | JSX.Element;
    severityColor: string;
    description: string;
    macroRegionName: string;
    regionName: string;
    powerStationId: number;
    powerStationName: string | JSX.Element;
    skidId: number;
    skidName: string | JSX.Element;
    equipmentId: number;
    equipmentName: string | JSX.Element;
    clearDate?: Date | string;
    acknowledgementDate?: Date | string;
    dateTime: Date | string;
    userName: string;
    group: boolean | any;
    hasAlarmSound: boolean;
    actionsConfig?: Array<ActionConfig>

}

const SKID_ALARM_PAGE_SIZE_KEY = 'skid-alarm-page-size';
const DEFAULT_PAGE_SIZE = 20;

const getInitialPageSize = (): number => {
    const storedSize = Number(Storage.local.get(SKID_ALARM_PAGE_SIZE_KEY, DEFAULT_PAGE_SIZE));
    if (Number.isFinite(storedSize) && storedSize > 0) {
        return storedSize;
    }
    return DEFAULT_PAGE_SIZE;
}

const AlarmPage:FunctionComponent<{skidId:any, advancedFilters:ADataGridFilter[] | null, hasClearFilters: (hasClearFilters: boolean) => void}> = ({skidId, advancedFilters, hasClearFilters}) => {
    const theme = useTheme();
    const dispatch = useAppDispatch();
    const { enqueueSnackbar } = useSnackbar();

    const isLoading = useAppSelector((state : RootState) => state.alarmSkid.loading);
    const totalOfRecords = useAppSelector((state : RootState) => state.alarmSkid.totalOfRecords);
    const entities: Array<Alarm> = useAppSelector((state: RootState) => state.alarmSkid.entities);
    
    const account = useAppSelector(state => state.authentication.account);
    const isAuthorizedToAcknowledge = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.DASHBOARD_SKID_ACKNOWLEDGE
    ]);

    const isAuthorizedToFinalize = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.DASHBOARD_SKID_FINALIZE
    ]);

    const navigationToPowerStation = usePowerStationNavigation();
    const navigationToSkid = useSkidNavigation();
    const navigationToEquipment = useEquipmentNavigation();
    const navigationToEquipmentWithoutSkid = useEquipmentWithoutSkidNavigation();


    const [rows, setRows] = useState<Array<AlarmRow>>([]);
    const [columns, setColumns] = useState<Array<ADataGridColumn>>(
        applyFiltersToAlarmColumns(initColumns, extractFiltersFromColumns(initColumns))
    );
    const [currentDataGridFilters, setCurrentDataGridFilters] = useState<Array<ADataGridFilter>>(
        extractFiltersFromColumns(initColumns)
    );

    const [pagedSearchParams, setPagedSearchParams] = useState(new PagedSearchParams(extractFiltersFromColumns(initColumns), 0, getInitialPageSize()));
    const [open, setOpen] = React.useState(false);
    const [notionOpen, setNotionOpen] = React.useState(false);
    const [groupOpen, setGroupOpen] = React.useState(false);
    const [entityToModel, setEntityToModel] = useState<object>();
    const [selectedRows, setSelectedRows] = useState<any>();
    const [hasAlarmSound, setHasAlarmSound] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [acknowledgeDialog, setAcknowledgeDialog] = useState(false);
    const userConfig = useAppSelector((state: RootState) => state.userConfigurarion);
    const [activeAdvancedFilters, setActiveAdvancedFilters] = useState<ADataGridFilter[] | null>(advancedFilters);

    // Sincroniza filtros avançados quando mudam
    useEffect(() => {
        setActiveAdvancedFilters(advancedFilters);
    }, [advancedFilters]);

    // Quando filtros avançados ou do DataGrid mudam, atualiza pagedSearchParams
    useEffect(() => {
        const mergedFilters = mergeAndDeduplicateFilters(currentDataGridFilters, activeAdvancedFilters, currentDataGridFilters);
        setPagedSearchParams((current) => {
            // Só atualiza se os filtros realmente mudaram
            if (JSON.stringify(current.filters) !== JSON.stringify(mergedFilters)) {
                return new PagedSearchParams(mergedFilters, 0, current.size);
            }
            return current;
        });
    }, [activeAdvancedFilters, currentDataGridFilters]);

    const handleOnRowOpen = useCallback(async (row: any) => {
        if(row && !isArray(row)){
            setGroupOpen(true);
            let params = new PagedSearchParams(extractFiltersFromColumns(initColumns), 0, getInitialPageSize());
            params.filters.push( { name: 'skidId', condition: 'equals', value: row.skidId.toString(), sort: 'none' })
            params.filters.push(...checkGroupingType(row))
            try {
                const hasGroup = await alarmSearchGroup(params);
                if (!hasGroup) {
                    enqueueSnackbar("Sem dados agrupados!", {variant: 'warning'})
                } else {
                    setEntityToModel(row)
                    setOpen(true);
                }
            } catch (error) {
                console.error(error);
            }
        } else {
            setOpen(false);
        }
    }, []);
    const handleOnNotionOpen = useCallback(async (data: any) => {
        if(data && !isArray(data)) {
            setNotionOpen(true);
            setEntityToModel(data);
            setOpen(true);
        }
    }, []);

    // close modal
    const handleCloseModal = () => {
        dispatch(clearGroup)
        setOpen(false);
        setGroupOpen(false);
        setNotionOpen(false);
    }

    const showAlarmDateFilterSanitizationMessage = (fieldLabels: Array<string>) => {
        enqueueSnackbar(buildAlarmDateFilterSanitizationMessage(fieldLabels), {variant: 'warning'});
    };

    const showAlarmDateFilterValidationMessage = (fieldLabels: Array<string>) => {
        enqueueSnackbar(buildAlarmDateFilterValidationMessage(fieldLabels), {variant: 'error'});
    };

    const validatePagedSearchParams = (params: PagedSearchParams, showMessage = true): PagedSearchParams | null => {
        const processedResult = processAlarmDateFilters(params.filters);

        if (processedResult.wasSanitized) {
            if (showMessage) {
                showAlarmDateFilterSanitizationMessage(processedResult.sanitizedFieldLabels);
            }
            return null;
        }

        if (!processedResult.isValid) {
            if (showMessage) {
                showAlarmDateFilterValidationMessage(processedResult.invalidFieldLabels);
            }
            return null;
        }

        return new PagedSearchParams(processedResult.convertedFilters, params.page, params.size);
    };

    const handleCleanFilters = () => {
        setActiveAdvancedFilters([]);
        const newPagedSearchParams = new PagedSearchParams([], 0, pagedSearchParams.size);
        setColumns(applyFiltersToAlarmColumns(initColumns, []));
        setCurrentDataGridFilters(newPagedSearchParams.filters);
        setPagedSearchParams(newPagedSearchParams);
        hasClearFilters(true);
    }

    const handleOnFiltersChange = useCallback((dataGridFilters: Array<ADataGridFilter>, page: number, pageSize: number) => {
        Storage.local.set(SKID_ALARM_PAGE_SIZE_KEY, pageSize);
        const processedResult = processAlarmDateFilters(dataGridFilters);

        // Sync columns only when sanitization changed values — avoids ADataGrid onFiltersChange loop
        if (processedResult.wasSanitized) {
            setColumns(applyFiltersToAlarmColumns(initColumns, processedResult.filters));
            showAlarmDateFilterSanitizationMessage(processedResult.sanitizedFieldLabels);
            return;
        }

        if (!processedResult.isValid) {
            showAlarmDateFilterValidationMessage(processedResult.invalidFieldLabels);
            return;
        }

        setCurrentDataGridFilters(processedResult.filters);

        const mergedFilters = mergeAndDeduplicateFilters(processedResult.filters, activeAdvancedFilters, processedResult.filters);
        setPagedSearchParams(new PagedSearchParams(mergedFilters, page, pageSize));
    }, [activeAdvancedFilters]);

    const ensureSkidIdInFilters = (params: PagedSearchParams): PagedSearchParams => {
        const hasSkidId = params.filters.some(f => f.name === 'skidId');

        if (!hasSkidId) {
            return new PagedSearchParams(
                [
                    { name: 'skidId', condition: 'equals', value: skidId.toString(), sort: 'none' },
                    ...params.filters
                ],
                params.page,
                params.size
            );
        } else {
            // Verifica se o valor está correto (pode ter sido alterado se skidId mudou)
            const updatedFilters = params.filters.map(f =>
                f.name === 'skidId' && f.value !== skidId.toString()
                    ? { ...f, value: skidId.toString() }
                    : f
            );
            return new PagedSearchParams(updatedFilters, params.page, params.size);
        }
    };

    useInterval(() => {
        if (!isLoading) {
            const validatedParams = validatePagedSearchParams(pagedSearchParams, false);

            if (validatedParams) {
                const safeParams = ensureSkidIdInFilters(validatedParams);
                dispatch(searchEntities({params: safeParams}));
            }
        }
    }, userConfig.alarmUpdateInterval, undefined, isLoading) // configured interval after the latest search finishes

    const finalizeAlarms = useCallback(async () => {
        handleClose()
        if(isArray(selectedRows)){
            const rowSelected = selectedRows.filter((row) => row.selected)
            const params:AlarmActionArgs = {
                alarmsListId: rowSelected.map((row) => Number(row.data.id))
            }
            const actionResult = await dispatch(alarmFinalize(params))
            if(alarmFinalize.fulfilled.match(actionResult)){
                const validatedParams = validatePagedSearchParams(pagedSearchParams, false);
                if (validatedParams) {
                    dispatch(searchEntities({params: ensureSkidIdInFilters(validatedParams)}))
                }
            }
        }else if(selectedRows){
            const actionResult = await dispatch(alarmFinalize({alarmsListId: [Number(selectedRows.id)]}))
            if(alarmFinalize.fulfilled.match(actionResult)){
                const validatedParams = validatePagedSearchParams(pagedSearchParams, false);
                if (validatedParams) {
                    dispatch(searchEntities({params: ensureSkidIdInFilters(validatedParams)}))
                }
            }
        }
    },[selectedRows]);


    const alarmAcknowledges = useCallback(async() => {
        handleClose()
        if(isArray(selectedRows)){
            const rowSelected = selectedRows.filter((row) => row.selected)
            const params:AlarmActionArgs = {
                alarmsListId: rowSelected.map((row) => Number(row.data.id))
            }
            const actionResult = await dispatch(alarmAcknowledge(params))
            if(alarmAcknowledge.fulfilled.match(actionResult)){
                dispatch(clear());
                const validatedParams = validatePagedSearchParams(pagedSearchParams, false);
                if (validatedParams) {
                    dispatch(searchEntities({params: ensureSkidIdInFilters(validatedParams)}))
                }
            }
        }else if(selectedRows){
            const actionResult = await dispatch(alarmAcknowledge({alarmsListId: [Number(selectedRows.id)]}))
            if(alarmAcknowledge.fulfilled.match(actionResult)){
                dispatch(clear());
                const validatedParams = validatePagedSearchParams(pagedSearchParams, false);
                if (validatedParams) {
                    dispatch(searchEntities({params: ensureSkidIdInFilters(validatedParams)}))
                }
            }
        }
    },[selectedRows]);

    const handleNavigationPowerPlant = (event: MouseEvent<HTMLElement>, powerPlantId: number): void => {
        event.preventDefault();
        navigationToPowerStation(powerPlantId);
    }

    const handleNavigationSkid = (event: MouseEvent<HTMLElement>, powerStationId: number, skidId: number): void => {
        event.preventDefault();
        navigationToSkid(powerStationId, skidId);
    }

    const handleNavigationEquipmentPage = (event: MouseEvent<HTMLElement>, powerPlantId: number, skidId: number | null, equipmentId: number): void => {
        event.preventDefault();
        if(powerPlantId != null && skidId != null){
            navigationToEquipment(equipmentId);
        } else {
            navigationToEquipmentWithoutSkid(equipmentId);
        }

    }



    const handleClickOpen = (rows:any) => {
        if(isAuthorizedToFinalize) {
            setSelectedRows(rows);
            setDialogOpen(true);
        } else {
            enqueueSnackbar("Você não está autorizado à acessar essa funcionalidade", {
                variant: 'warning',
            });
            return null;
        }
    };

    const handleAcknowledgeClick = (rows:any) => {
        if(isAuthorizedToAcknowledge) {
            setSelectedRows(rows);
            setAcknowledgeDialog(true)
        } else {
            enqueueSnackbar("Você não está autorizado à acessar essa funcionalidade", {
                variant: 'warning',
            });
            return null;
        }
        
    }

    const handleClose = () => {
        setDialogOpen(false);
        setAcknowledgeDialog(false);
    };

    const structureRow = (entitiesValues: Array<Alarm>) => {
        let newHasAlarmSound = false;
        let alarms: Array<AlarmRow> = []
        entitiesValues.forEach( alarm => {
            alarms.push({
                id: alarm.id.toString(),
                teleObjectId: alarm.teleObjectId,
                teleObjectInhibited: alarm.teleObjectInhibited,
                group: alarm.group,
                severityId: alarm.severityId,
                severityName: alarm.teleObjectInhibited
                    ? getAlarmDisplayLabel(alarm)
                    : (alarm?.clearDate == null || alarm?.clearDate.length < 1) && (alarm?.acknowledgementDate == null || alarm?.acknowledgementDate.length < 1) && alarm.hasAlarmSound ?
                    <>
                        <VolumeUpIcon fontSize="small" sx={{ verticalAlign: 'middle', marginRight: 0.5, color: theme.palette.primary.main }}/>
                        {alarm.severityName}
                    </> : alarm.severityName,
                severityColor: alarm.severityColor,
                description: alarm.description,
                macroRegionName: alarm.macroRegionName,
                regionName: alarm.regionName,
                powerStationId: alarm.powerStationId,
                powerStationName: <Link href="#" onClick={(event) => handleNavigationPowerPlant(event, alarm.powerStationId)} underline="hover">{alarm.powerStationName}</Link>,
                skidId: alarm.skidId,
                skidName:<Link href="#" onClick={(event) => handleNavigationSkid(event, alarm.powerStationId, alarm.skidId)} underline="hover">{alarm.skidName}</Link>,
                equipmentId: alarm.equipmentId,
                equipmentName: <Link href="#" onClick={(event) => handleNavigationEquipmentPage(event, alarm.powerStationId, alarm.skidId, alarm.equipmentId)}>{alarm.equipmentName}</Link>,                clearDate: alarm.clearDate ? DateFormat(alarm.clearDate) : "",
                acknowledgementDate: alarm.acknowledgementDate ? DateFormat(alarm.acknowledgementDate) : "",
                dateTime: DateFormat(alarm.dateTime),
                userName: alarm.userName,
                hasAlarmSound: alarm.hasAlarmSound,
                actionsConfig: [
                    {actionName: "grouping", disabled: false},
                    {actionName: "note", disabled: false},
                    {actionName: "acknowledge", disabled: isAuthorizedToAcknowledge ? (alarm.acknowledgementDate != null) : true},
                    {actionName: "finalize", disabled: isAuthorizedToFinalize ? (alarm.clearDate != null) : true}
                ],
            });
            if((alarm?.clearDate == null || alarm?.clearDate.length < 1) && (alarm?.acknowledgementDate == null || alarm?.acknowledgementDate.length < 1) && alarm?.hasAlarmSound === true && !newHasAlarmSound){
                newHasAlarmSound = true;
            }
        });
        setHasAlarmSound(newHasAlarmSound);
        setRows(alarms);
    }

    const alarmSound = async () => {
        const audio = new Audio(process.env.PUBLIC_URL + "/notification_02.mp3");
        audio.volume = 0.7;
        const audioMuted = localStorage.getItem("audioMuted") === "true";
        try {
            await new Promise((resolve) => {
                
                audio.onended = resolve;
                audio.oncanplay = () => {
                
                    audio.muted = !audioMuted;
                    if(audioMuted){
                        audio.play();
                    }
                };
            });
        } catch (err) {
            console.log("error", err);
        }
    }
    // Effects
    const paramsRef = useRef(false);
    const entitiesRef = useRef(false);
    const columnsRef = useRef(false);

    useEffect(() => {
        if (!isLoading) {
            if(paramsRef.current){
                const validatedParams = validatePagedSearchParams(pagedSearchParams);

                if (!validatedParams) {
                    return;
                }

                const safeParams = ensureSkidIdInFilters(validatedParams);
                dispatch(searchEntities({params: safeParams}));

            }else {
                paramsRef.current = true;
            }
        }
    }, [skidId, pagedSearchParams])


    useEffect(() => {        
        if (hasAlarmSound) {
            const intervalo = setInterval(() => {                
                alarmSound();
            }, 2000);
      
            return () => clearInterval(intervalo);
        }
    },[hasAlarmSound]);

    useEffect(() => {
        if(!entitiesRef.current){
            entitiesRef.current = true;
        }
        if (isArray(entities) && entities.length > 0) {
            structureRow(entities);
        }else {
            setRows([]);
            setHasAlarmSound(false);
        }
    },[entities]);

    useEffect(() => {
        if(!columnsRef.current){
            columnsRef.current = true;
        }
    },[initColumns]);

    const newHandleOnColor = (data: any, columnItem: any): ADataGridColors => {
        return handleOnColor(data,columnItem,theme);
    }

return (
        <ACard ariaLabel={"skid-alarm"}
            styleProps={{
                cardStyle: {cursor: isLoading ? 'wait' : 'default', boxShadow: 'none'},
                contentStyle: { padding: '0 0px 10px 0' },
            }}
            headerControls={
                <LoadingButton
                    variant="text"
                    color="primary"
                    onClick={handleCleanFilters}
                    endIcon={<FilterAltOutlined />}
                    disabled={isLoading}
                >
                    Limpar filtros
                </LoadingButton>

            }
        >
            <ADataGrid
                noMaxHeight={true}
                hideFilters={false}
                showFilterOptions={false}
                hideSelection={false}
                size={"small"}
                columns={columns}
                rows={rows}
                page={pagedSearchParams.page}
                loading={false}
                totalOfRecords={totalOfRecords || 0}
                rowsPerPage={pagedSearchParams.size}
                onFiltersChange={handleOnFiltersChange}
                onColorSelect={newHandleOnColor}
                actionColumnWidth={200}
                actionColumnStyle={{minWidth: 200}}
                disableActionsHeaderIcons={false}
                actions={
                    <>
                        <IconButton {...({ disableHeader: true } as any)} name="grouping" size={"small"} aria-label="Fact check" onClick={handleOnRowOpen}>
                            <Tooltip title="Agrupamento">
                                <FactCheck/>
                            </Tooltip>
                        </IconButton>

                        <IconButton {...({ disableHeader: true } as any)} name="note" size={"small"} aria-label="Border color" onClick={handleOnNotionOpen}>
                            <Tooltip title="Adicionar nota">
                                <BorderColor />
                            </Tooltip>
                        </IconButton>
                        <IconButton name="acknowledge" size={"small"} aria-label="Fact check" onClick={handleAcknowledgeClick} disabled={!isAuthorizedToAcknowledge}>
                            <Tooltip title="Reconhecer alarme">
                                <CheckCircleIcon />
                            </Tooltip>
                        </IconButton>
                        <IconButton name="finalize" size={"small"} aria-label="Border color" onClick={handleClickOpen} disabled={!isAuthorizedToFinalize}>
                            <Tooltip title="Finalizar alarme">
                                <CancelIcon />
                            </Tooltip>
                        </IconButton>
                    </>
                }
            />
            <Modal
                open={open}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                { groupOpen && !notionOpen ?
                    <AlarmGroup alarm={entityToModel} />
                    :
                    <AlarmNotion alarm={entityToModel} />
                }
            </Modal>
            <Dialog open={dialogOpen || acknowledgeDialog} onClose={handleClose}>
                <DialogTitle>{`Confirmar ${dialogOpen ? 'finalização' : 'reconhecimento'}`}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Tem certeza de que deseja {dialogOpen ? 'finalizar' : 'reconhecer'} este alarme?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancelar</Button>
                    <Button onClick={dialogOpen ? finalizeAlarms : alarmAcknowledges} autoFocus>
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
        </ACard>
    )
}

export default AlarmPage;
